import React from 'react'
import './HotelChain.css'
import { Container, Row, Col } from 'react-bootstrap'

function HotelChains() {
  return (
    <div className='box-HotelChaincontainer'>
      <Container className='box-container'>
        <div className='box-heading'>Our Top Hotel Chains</div>
        <p className='box-paragraph'>Innovate Blues offers a wide selection of luxury and budget-friendly hotel chains across India. We've curated top-rated properties that deliver both comfort and class, ensuring every stay feels like a personalized experience. Whether you're traveling for business or leisure, Innovate Blues helps you find the perfect hotel that suits your needs and budget. Our listed hotels are safe, hygienic, and conveniently located, making your travel experience seamless. Book your next stay with Innovate Blues and unlock exclusive deals to save big on your accommodation.</p>
        <div className='box'>
           <div className='box1'><img src="/Images/Images/hotel1.png" alt="" /></div>
           <div className='box1'><img src="/Images/Images/hotel2.webp" alt="" /></div>
           <div className='box1'><img src="/Images/Images/hotel3.webp" alt="" /></div>
           <div className='box1'><img src="/Images/Images/hotel4.webp" alt="" /></div>
           <div className='box1'><img src="/Images/Images/hotel5.webp" alt="" /></div>
           <div className='box1'><img src="/Images/Images/hotel6.webp" alt="" /></div>
           <div className='box1'><img src="/Images/Images/hotel7.png" alt="" /></div>
           <div className='box1'><img src="/Images/Images/hotel8.png" alt="" /></div>
           <div className='box1'><img src="/Images/Images/hotel9.png" alt="" /></div>
           <div className='box1'><img src="/Images/Images/hotel10.webp" alt="" /></div>
           <div className='box1'><img src="/Images/Images/hotel11.webp" alt="" /></div>
           <div className='box1'><img src="/Images/Images/hotel2.webp" alt="" /></div>
           <div className='box1'><img src="/Images/Images/hotel3.webp" alt="" /></div>
           <div className='box1'><img src="/Images/Images/hotel4.webp" alt="" /></div>
           <div className='box1'><img src="/Images/Images/hotel15.webp" alt="" /></div>
           <div className='box1'><img src="/Images/Images/hotel6.webp" alt="" /></div>
           <div className='box1'><img src="/Images/Images/hotel17.webp" alt="" /></div>
           
        </div>
      </Container>
    </div>
  )
}

export default HotelChains
